module.exports = __webpack_public_path__ + "static/media/Jamaica.a9f9619e.png";